// Visitors: tips for when people come round, and the socialisation items a
// visit from someone can count towards (content/socialisation.ts → People).

export const VISITOR_TRAITS: { id: string; label: string }[] = [
  { id: 'men', label: 'Man / deep voice' },
  { id: 'children', label: 'Child' },
  { id: 'toddlers', label: 'Toddler or baby' },
  { id: 'older-people', label: 'Older person / walking aid' },
  { id: 'beards-glasses', label: 'Beard or glasses' },
  { id: 'hats-hoods', label: 'Usually wears a hat or hood' },
  { id: 'hi-vis', label: 'Uniform or hi-vis' },
  { id: 'wheelchairs', label: 'Wheelchair or scooter' },
];

export const RELATIONS: { value: NonNullable<import('../domain/types.ts').Visitor['relation']>; label: string }[] = [
  { value: 'family', label: 'Family' },
  { value: 'friend', label: 'Friend' },
  { value: 'neighbour', label: 'Neighbour' },
  { value: 'child', label: 'Child' },
  { value: 'helper', label: 'Sitter / walker' },
  { value: 'other', label: 'Other' },
];

/** What to tell visitors, in order: the door, the hello, the visit. */
export const VISITOR_TIPS: { title: string; detail: string }[] = [
  { title: 'At the door', detail: 'He waits behind a gate or in his pen while you answer. Visitors say hello only once all four paws are on the floor — jumping gets a quiet turn away.' },
  { title: 'Shoes off, hands washed', detail: 'Until he’s fully vaccinated, anything picked up on shoes or from their own dog (parvovirus) can come in with them.' },
  { title: 'Let him come to them', detail: 'Sitting on the floor and letting him choose to come over is kindest. Treats tossed on the floor, not held in fingers; a gentle stroke on his side or chest. No hand games, picking up or hugging. If he mouths: go still, no squealing, and offer the toy we keep by the door.' },
  { title: 'Children', detail: 'Sitting down, one at a time, always supervised — no running or shrieking near him. If he gets nippy, calmly swap in a toy, then a breather in his pen with a chew.' },
  { title: 'A toilet trip early on', detail: 'Excitement means wees. Take him out soon after they arrive.' },
  { title: 'Naps still happen', detail: 'After about an hour awake he goes to his crate with a chew, guests or not. His crate is a no-visitor zone.' },
];
